import React from 'react';

const SkylineStyles = () => (
  <style>{`
    @keyframes horizon-reveal {
      from { clip-path: inset(0 100% 0 0); }
      to   { clip-path: inset(0 0% 0 0); }
    }
    @keyframes cloud-drift {
      from { transform: translateX(-25%); }
      to   { transform: translateX(125%); }
    }
    @keyframes cloud-drift-rev {
      from { transform: translateX(125%); }
      to   { transform: translateX(-25%); }
    }
    @keyframes tram-roll {
      from { transform: translateX(-15%); }
      to   { transform: translateX(115%); }
    }
    @keyframes blink-window {
      0%, 92%, 100% { opacity: 0.1; }
      50%           { opacity: 0.95; }
    }
    @keyframes star-twinkle {
      0%, 100% { opacity: 0.25; transform: scale(0.85); }
      50%      { opacity: 0.85; transform: scale(1.15); }
    }
    @keyframes flag-wave {
      0%, 100% { transform: skewX(0deg) translateX(0); }
      50%      { transform: skewX(-12deg) translateX(2px); }
    }
    @keyframes wheel-spin {
      from { transform: rotate(0deg); }
      to   { transform: rotate(360deg); }
    }
    .cs-skyline {
      animation: horizon-reveal 3800ms cubic-bezier(0.65, 0, 0.35, 1) forwards;
    }
    .cs-cloud  { animation: cloud-drift 38s linear infinite; }
    .cs-cloud-rev { animation: cloud-drift-rev 52s linear infinite; }
    .cs-tram   { animation: tram-roll 22s linear 4s infinite; }
    .cs-win    { animation: blink-window 6.4s ease-in-out infinite; }
    .cs-star   { animation: star-twinkle 3.2s ease-in-out infinite; }
    .cs-flag   { animation: flag-wave 2.4s ease-in-out infinite; transform-origin: left center; }
    .cs-wheel  { animation: wheel-spin 80s linear infinite; transform-origin: 1320px 80px; }
  `}</style>
);

export default SkylineStyles;
